import confs from "../configurations";
import { request } from "../request";

const { URL_API } = confs;

const sdk = {
  //
  me: {
    //
    translations: {
      get: (params) => request.get(URL_API + "/me/translations", params),
    },
    dataTranslations: {
      get: (params) => request.get(URL_API + "/me/data_translations", params),
    },
    configuration: {
      get: () => request.get(URL_API + "/me/configuration"),
    },
    departments: {
      get: () => request.get(URL_API + "/me/departments"),
    },
  },
  products: {
    associateProducts: {
      getCollection: (codarts) =>
        request.get(URL_API + "/products/associate_products", codarts),
    },
  },
  commande: {
    history: {
      get: (clientId) => request.get(URL_API + "/commande/history/" + clientId),
    },
  },
  users: {
    loyalty: (currentYear, codcli) =>
      request.get(URL_API + "/users/loyalty/" + currentYear + "/" + codcli),
    newsletter: (formData) =>
      request.post(URL_API + "/users/newsletter", formData),
  },
  //
  orders: {
    create: (order) => request.post(URL_API + "/orders/create", order),
    saveCartDB: (clientId, order) =>
      request.post(URL_API + "/orders/save_cart/" + clientId, order),
    updateCartDB: (order) =>
      request.post(URL_API + "/orders/update_cart", order),
    deleteAllCartDB: (codcli) =>
      request.post(URL_API + "/orders/deleteAllcart/".concat(codcli)),
    deletecartByIdDB: (codcli, id) =>
      request.post(
        URL_API +
        "/orders/deletebycartid/".concat(codcli).concat("/").concat(id)
      ),
    checkAndSavecartbyIdDB: (codcli, id, cart, signal) =>
      request.post(
        URL_API +
        "/orders/checkAndSavecartbyid/".concat(codcli).concat("/").concat(id),
        cart,
        {},
        signal
      ),
  },
};

export default sdk;
